// Returns the "anchor" Saturday (YYYY-MM-DD in LOCAL time) for the
// Sabbath School lesson that should be displayed right now.
//
// Rule: Saturday before noon → still showing previous week's lesson.
//       Saturday noon+ or any other day → current lesson.
//
// Uses getFullYear/getMonth/getDate (never toISOString) so the date
// is always in local timezone, matching the fecha_inicio / dia.fecha
// strings stored in Supabase.
export function getLessonAnchorDate() {
  const now = new Date();
  const dow = now.getDay();   // 0 Sun … 6 Sat
  const hrs = now.getHours();

  // Days elapsed since last Saturday (0 when today IS Saturday)
  const daysSinceSat = (dow + 1) % 7;

  const anchor = new Date(now);
  anchor.setDate(now.getDate() - daysSinceSat);

  // Saturday-noon rule: before 12:00 on Saturday → previous lesson week
  if (dow === 6 && hrs < 12) {
    anchor.setDate(anchor.getDate() - 7);
  }

  anchor.setHours(0, 0, 0, 0);

  const y = anchor.getFullYear();
  const m = String(anchor.getMonth() + 1).padStart(2, "0");
  const d = String(anchor.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
